import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { dateFilter } from "vue-date-fns";
import 'leaflet/dist/leaflet.css';

let app = createApp(App);

app.config.globalProperties.$filters = {
    dateFilter
}

app.use(router).mount('#app');